// extracted by mini-css-extract-plugin
export default {"main":"MethodForm_main__dnRMi","addBtn":"MethodForm_addBtn__0bMfo","label":"MethodForm_label__8HI3r"};